import DynamicImage from '@/components/commons/dynamic-image';
import { BlogHomeListElementDataType } from '@/components/sections/builder/elements/body/blog-home/type';
import { BlogPostListElementDataType } from '@/components/sections/builder/elements/body/blog-post/type';
import { getOverrideAnimationParams } from '@/components/sections/builder/settings/animation-setting';
import { cn, removeHTMLTags, truncateText } from '@/lib/utils';
import { ThemeType } from '@/stores/builder';
import { HttpTypes } from '@/types';
import { format } from 'date-fns';
import Link from 'next/link';

type DetailContentType = {
  data: BlogHomeListElementDataType | BlogPostListElementDataType;
  blog: HttpTypes.StoreBlogPostElementListResponse;
  elementId: string;
  index: number;
  theme: ThemeType;
};

export default function DetailContent({ data, blog, elementId, index, theme }: DetailContentType) {
  return (
    <article
      className='post-gap'
      data-animation='true'
      data-animation-group={`blog-item-${elementId}`}
      {...getOverrideAnimationParams(data.animation, index)}
    >
      <Link href={`/blogs/${blog.slug_category}/${blog.slug}`}>
        <div
          className={cn(
            'theme_animation_card_hover font_color flex flex-col justify-between overflow-hidden rounded-none',
            data.showShadow && 'shadow-md'
          )}
        >
          <div className=''>
            {data.showImage && (
              <div className='image_padding'>
                <DynamicImage
                  src={blog.image_banner}
                  alt='Blogs Images'
                  width={600}
                  height={400}
                  className='aspect-[3/2] w-full object-cover'
                />
              </div>
            )}
            <div className='pb-1 pt-4 '>
              <h2 className='mb-2 '>
                <Link href={`/blogs/${blog.slug_category}/${blog.slug}`}>
                  {truncateText(blog.title, theme?.blogCard?.limitCharacters as number)}
                </Link>
              </h2>
              {data.showContent && (
                <p className='mb-5 line-clamp-3 font-light'>
                  {removeHTMLTags(blog.content || 'No description available')}
                </p>
              )}
            </div>
          </div>
          <div>
            <div className='flex items-center justify-between'>
              {data.showAuthor && (
                <div className='flex items-center space-x-2'>
                  {/* temporary hide */}
                  {/* <img
            className='rounded-full h-7 w-7'
            src='https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/jese-leos.png'
            alt='Jese Leos avatar'
          /> */}
                  <span className='font-medium'>{blog.author}</span>
                </div>
              )}
              {data.showDate && <span>{format(new Date(blog.created_at), 'MMMM dd, yyyy')}</span>}
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}
